var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('form-radio-dot',{staticClass:"switch-dot",attrs:{"checked":_vm.checked}}),_c('span',{staticClass:"box-label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }